import { useCallback, useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import {
  createUserWithEmailAndPassword,
  RecaptchaVerifier,
  signInWithPhoneNumber,
  GoogleAuthProvider,
  signInWithPopup,
  sendEmailVerification,
} from "firebase/auth";
import init from "../../firebase";
import { toast } from "react-toastify";
import { getFirebaseErrorMessage } from "../getFirebaseErrorMessage";
import { useUserAuth } from "../../context/UserAuthContext";
import { MdRemoveRedEye } from "react-icons/md";
import { IoMdEyeOff } from "react-icons/io";
import axios from "axios";
import Swal from "sweetalert2";
import { FcGoogle } from "react-icons/fc";
import { Modal } from "react-bootstrap";
import Select from "react-select";

const CreateProfile = () => {
  const { language } = useUserAuth();
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [currencies, setCurrencies] = useState([]);
  const base_url = import.meta.env.VITE_LOCAL_BASE_URL;
  const auth = init.auth;
  const provider = new GoogleAuthProvider();
  const [canResend, setCanResend] = useState(false);
  const [resendTimer, setResendTimer] = useState(0);

  // const emp_code = localStorage.getItem("emp_code");
  const [empCode, setEmpCode] = useState(null);
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const emp_code = params.get("emp_code");
    if (emp_code) setEmpCode(emp_code);
  }, []);

  const [formData, setFormData] = useState({
    business_name: "",
    email: "",
    password: "",
    mobno: "",
    otp: "",
    refer_code: "",
  });

  const [errors, setErrors] = useState({
    business_name: "",
    email: "",
    password: "",
    mobno: "",
    otp: "",
  });

  const [agreeToTerms, setAgreeToTerms] = useState(false);
  const [showTermsModal, setShowTermsModal] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showOtp, setShowOtp] = useState(false);
  const [currentTab, setCurrentTab] = useState("Mobile");
  const [googleLoading, setGoogleLoading] = useState(false);

  let { cat_id, sub_cat_id } = useParams();
  let navigate = useNavigate();
  const [shortCode, setShortCode] = useState();
  useEffect(() => {
    let interval;

    if (resendTimer > 0) {
      interval = setInterval(() => {
        setResendTimer((prev) => prev - 1);
      }, 1000);
    } else if (resendTimer === 0 && showOtp) {
      setCanResend(true);
    }

    return () => clearInterval(interval);
  }, [resendTimer, showOtp]);

  // Google Sign In Handler
  const handleGoogleLogin = async () => {
    setGoogleLoading(true);
    try {
      const result = await signInWithPopup(auth, provider);
      const user = result.user;
      console.log("Google user:", user);
      const checkUserResponse = await axios.get(
        `${base_url}/api/v1/users/exist/${user.uid}`,
      );
      const userExists = checkUserResponse.data?.data?.exists;
      if (userExists) {
        toast.success(
          language === "en"
            ? "Welcome back!"
            : "वापसी पर स्वागत है! रीडायरेक्ट हो रहा है...",
        );
        navigate("/dashboard/dash_board");
        return;
      }
      let code;
      try {
        const res = await axios.get(
          `${base_url}/api/v1/generate-short-code/vendor/${cat_id}/${sub_cat_id}`,
        );
        code = res.data.short_code;
        setShortCode(res.data.short_code);
      } catch (err) {
        const res = getFirebaseErrorMessage(err.code);
        console.log("Error generating short code:", err);
        toast.error(res);
        return;
      }
      const userData = {
        id: user.uid,
        category_id: cat_id,
        sub_category_id: sub_cat_id,
        business_name: user.displayName || user.email.split("@")[0],
        email: user.email,
        mobno: user.phoneNumber || "",
        refer_code: formData.refer_code || "",
        role: "merchant",
        short_code: shortCode || code,
        emp_code: empCode,
        currencies_id: selectedCountry?.id || null,
        signup_type: "google",
        signup_source:"web"
      };
      const response = await axios.post(
        `${base_url}/api/v1/users/sign-up`,
        userData, 
      );
      try {
        await axios.post(`${base_url}/api/v1/vendor-activity`, {
          vendor_id: user?.uid,
          action_type: "onboarding",
          action: "create",
          status: "pending",
          note:'Profile created via Google'
        });
      } catch (err) {
        console.log("vendor log genrating error", err);
      }
      if (response?.data?.statusCode === 404) {
        toast.error(
          "A user with the same business name already exists. Plase try again with other business name.",
        );
        return;
      }
      console.log("Google signup success:", response.data);
      navigate("/vendor-mobno-verification");
    } catch (error) {
      console.error("Google sign in error:", error);
      const errorMsg = getFirebaseErrorMessage(error.code);
      Swal.fire({
        title: errorMsg,
        icon: "error",
        showCloseButton: true,
        cancelButtonText: language === "en" ? "Close" : "बंद करें",
        showConfirmButton: false,
        cancelButtonColor: "#085f9a",
      });
    } finally {
      setGoogleLoading(false);
    }
  };

  const validateField = (name, value) => {
    let error = "";
    switch (name) {
      case "business_name":
        if (!value.trim()) {
          error =
            language === "en"
              ? "Business name is required"
              : "व्यवसाय का नाम आवश्यक है";
        }
        break;
      case "email":
        if (!value.trim()) {
          error = language === "en" ? "Email is required" : "ईमेल आवश्यक है";
        } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
          error =
            language === "en" ? "Invalid email format" : "अमान्य ईमेल प्रारूप";
        }
        break;
      case "password":
        if (!value.trim()) {
          error =
            language === "en" ? "Password is required" : "पासवर्ड आवश्यक है";
        } else if (value.length < 6) {
          error =
            language === "en"
              ? "Password must be at least 6 characters"
              : "पासवर्ड कम से कम 6 अक्षरों का होना चाहिए";
        }
        break;
      case "mobno":
        if (value && !/^\d{6,14}$/.test(value)) {
          error =
            language === "en" ? "Invalid mobile number" : "अमान्य मोबाइल नंबर";
        }
        break;
      case "otp":
        if (!value.trim()) {
          error = language === "en" ? "OTP is required" : "OTP आवश्यक है";
        } else if (!/^\d{6}$/.test(value)) {
          error =
            language === "en"
              ? "OTP must be 6 digits"
              : "OTP 6 अंकों का होना चाहिए";
        }
        break;
      default:
        break;
    }

    return error;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "mobno") {
      const numValue = value.replace(/\D/g, "").slice(0, 10);
      setFormData((prev) => ({ ...prev, [name]: numValue }));
      setErrors((prev) => ({ ...prev, [name]: validateField(name, numValue) }));
      return;
    }
    if (name === "otp") {
      const numValue = value.replace(/\D/g, "").slice(0, 6);
      setFormData((prev) => ({ ...prev, [name]: numValue }));
      setErrors((prev) => ({ ...prev, [name]: validateField(name, numValue) }));
      return;
    }

    setFormData((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: validateField(name, value) }));
  };
  const onCaptchaVerify = () => {
    if (!window.recaptchaVerifier) {
      window.recaptchaVerifier = new RecaptchaVerifier(
        auth,
        "recaptcha-container",
        {
          size: "invisible",
          callback: (response) => {},
          "expired-callback": () => {},
        },
        auth,
      );
    }
  };

  const handleSendOtp = async (e) => {
    e.preventDefault();

    const mobnoError = validateField("mobno", formData.mobno);
    if (mobnoError) {
      setErrors((prev) => ({ ...prev, mobno: mobnoError }));
      return;
    }

    const isExistResponse = await axios.post(`${base_url}/api/v1/users/exist`, {
      business_name: formData.business_name,
    });
    const isUserAlready = isExistResponse?.data?.data?.exists || false;
    if (isUserAlready) {
      Swal.fire({
        title:
          language === "en"
            ? "Business Name Already Exists"
            : "व्यवसाय का नाम पहले से मौजूद है",
        text:
          language === "en"
            ? "Please choose a different business name."
            : "कृपया कोई अलग व्यवसाय नाम चुनें।",
        icon: "error",
        iconColor: "#d33",
        background: "#fefefe",
        color: "#333",
        showCloseButton: true,
        cancelButtonText: language === "en" ? "Close" : "बंद करें",
        showConfirmButton: false,
        cancelButtonColor: "#d33",
        customClass: {
          popup: "swal-wide",
          cancelButton: "custom-cancel-btn",
          title: "custom-title",
          htmlContainer: "custom-text",
        },
      });
      return;
    }

    setLoading(true);
    onCaptchaVerify();

    const appVerifier = window.recaptchaVerifier;
    const countryCode = selectedCountry?.code || "91";
    const formatPh = "+" + countryCode + formData.mobno;

    try {
      const confirmationResult = await signInWithPhoneNumber(
        auth,
        formatPh,
        appVerifier,
      );
      window.confirmationResult = confirmationResult;
      setShowOtp(true);
      setCanResend(false);
      setResendTimer(30);
      toast.success(
        language === "en"
          ? "OTP sent successfully!"
          : "OTP सफलतापूर्वक भेजा गया!",
      );
    } catch (error) {
      const res = getFirebaseErrorMessage(error.code);
      Swal.fire({
        title: res,
        icon: "error",
        showCloseButton: true,
        cancelButtonText: language === "en" ? "Close" : "बंद करें",
        showConfirmButton: false,
        cancelButtonColor: "#085f9a",
      });
      console.error("OTP sending error:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleEmailSignup = async (e) => {
    e.preventDefault();

    // Validate required fields
    const newErrors = {
      business_name: validateField("business_name", formData.business_name),
      email: validateField("email", formData.email),
      password: validateField("password", formData.password),
      mobno: validateField("mobno", formData.mobno),
    };

    setErrors(newErrors);

    // Check if any errors exist
    if (Object.values(newErrors).some((error) => error)) {
      return;
    }

    const isExistResponse = await axios.post(`${base_url}/api/v1/users/exist`, {
      business_name: formData.business_name,
    });
    const isUserAlready = isExistResponse?.data?.data?.exists || false;
    if (isUserAlready) {
      Swal.fire({
        title:
          language === "en"
            ? "Business Name Already Exists"
            : "व्यवसाय का नाम पहले से मौजूद है",
        text:
          language === "en"
            ? "Please choose a different business name."
            : "कृपया कोई अलग व्यवसाय नाम चुनें।",
        icon: "error",
        iconColor: "#d33",
        background: "#fefefe",
        color: "#333",
        showCloseButton: true,
        cancelButtonText: language === "en" ? "Close" : "बंद करें",
        showConfirmButton: false,
        cancelButtonColor: "#d33",
        customClass: {
          popup: "swal-wide",
          cancelButton: "custom-cancel-btn",
          title: "custom-title",
          htmlContainer: "custom-text",
        },
      });
      return;
    }

    setLoading(true);
    let code;
    try {
      const res = await axios.get(
        `${base_url}/api/v1/generate-short-code/vendor/${cat_id}/${sub_cat_id}`,
      );
      code = res.data.short_code;
      setShortCode(res.data.short_code);
    } catch (err) {
      console.error("Error fetching merchants:", err);
    }

    try {
      const user = await createUserWithEmailAndPassword(
        auth,
        formData.email,
        formData.password,
      );
      await sendEmailVerification(auth.currentUser);
      const documentId = user.user.uid;
      const data = {
        id: documentId,
        category_id: cat_id,
        sub_category_id: sub_cat_id,
        business_name: formData.business_name,
        email: formData.email,
        password: formData.password,
        mobno: formData.mobno || "",
        refer_code: formData.refer_code || "",
        role: "merchant",
        short_code: shortCode || code,
        emp_code: empCode,
        currencies_id: selectedCountry?.id || null,
        signup_type: "email",
        signup_source:"web"
      };
      const res = await axios.post(`${base_url}/api/v1/users/sign-up`, data);
      console.log(res.data);
      toast.success(
        language === "en"
          ? "Profile created successfully!"
          : "प्रोफाइल सफलतापूर्वक बनाई गई!",
      );
      try {
        await axios.post(`${base_url}/api/v1/vendor-activity`, {
          vendor_id: documentId,
          action_type: "onboarding",
          action: "create",
          status: "pending",
          note:"Profile created via Email"
        });
      } catch (err) {
        console.log("vendor log genrating error", err);
      }
      navigate("/basic-detail");
    } catch (err) {
      const res = getFirebaseErrorMessage(err.code);
      toast.error(res);
      console.error("Signup error:", err);
    } finally {
      setLoading(false);
    }
  };

  const handleOtpVerify = async (e) => {
    e.preventDefault();
    const otpError = validateField("otp", formData.otp);
    if (otpError) {
      setErrors((prev) => ({ ...prev, otp: otpError }));
      return;
    }

    setLoading(true);

    try {
      const result = await window.confirmationResult.confirm(formData.otp);
      const documentId = result.user.uid;
      const resp = await axios.get(
        `${base_url}/api/v1/users/mobile-verification/${documentId}`,
      );

      if (resp.data.isExist) {
        toast.error(
          language === "en"
            ? "Your account already exists! Please Login to continue"
            : "आपका खाता पहले से मौजूद है! जारी रखने के लिए कृपया लॉगिन करें",
        );
        navigate("/");
      } else {
        let code;
        try {
          const res = await axios.get(
            `${base_url}/api/v1/generate-short-code/vendor/${cat_id}/${sub_cat_id}`,
          );
          code = res.data.short_code;
          setShortCode(res.data.short_code);
        } catch (err) {
          console.error("Error fetching merchants:", err);
        }
        const data = {
          id: documentId,
          category_id: cat_id,
          sub_category_id: sub_cat_id,
          business_name: formData.business_name,
          mobno: formData.mobno,
          refer_code: formData.refer_code || "",
          role: "merchant",
          short_code: shortCode || code,
          emp_code: empCode,
          currencies_id: selectedCountry?.id || null,
          signup_type: "mobile",
          signup_source:"web"
        };
        const res = await axios.post(`${base_url}/api/v1/users/sign-up`, data);
        console.log(res.data);
        toast.success(
          language === "en"
            ? "Profile created successfully!"
            : "प्रोफाइल सफलतापूर्वक बनाई गई!",
        );
        try {
          await axios.post(`${base_url}/api/v1/vendor-activity`, {
            vendor_id: documentId,
            action_type: "onboarding",
            action: "create",
            status: "pending",
            note:"Profile created via Mobile Number"
          });
        } catch (err) {
          console.log("vendor log genrating error", err);
        }
        navigate("/basic-detail");
      }
    } catch (err) {
      const res = getFirebaseErrorMessage(err.code);
      Swal.fire({
        title: res,
        icon: "error",
        showCloseButton: true,
        cancelButtonText: language === "en" ? "Close" : "बंद करें",
        showConfirmButton: false,
        cancelButtonColor: "#085f9a",
      });
      console.log("OTP verification error:", err);
    } finally {
      setLoading(false);
    }
  };
  const resendVerificationCode = async () => {
    if (!canResend) return;
    setCanResend(false);
    try {
      onCaptchaVerify();
      const appVerifier = window.recaptchaVerifier;
      const countryCode = selectedCountry?.code || "91";
      const formatPh = "+" + countryCode + formData.mobno;
      const confirmationResult = await signInWithPhoneNumber(
        auth,
        formatPh,
        appVerifier,
      );

      window.confirmationResult = confirmationResult;

      toast.success(
        language === "en" ? "OTP resent successfully!" : "OTP फिर से भेजा गया!",
      );
      setResendTimer(30);
    } catch (error) {
      const res = getFirebaseErrorMessage(error.code);
      Swal.fire({
        title: res,
        icon: "error",
        showCloseButton: true,
        showConfirmButton: false,
      });
    }
  };
  const switchTab = (tab) => {
    setCurrentTab(tab);
    setShowOtp(false);
    setErrors({
      business_name: "",
      email: "",
      password: "",
      mobno: "",
      otp: "",
    });
  };

  // Fetch all countries
  const fetchCurrency = useCallback(async () => {
    try {
      const res = await axios.get(`${base_url}/api/v1/currency/country`);
      const data = Array.isArray(res?.data?.data) ? res?.data?.data : [];
      setCurrencies(data);

      // Set default to India if no country selected
      if (!selectedCountry) {
        const india = data.find((c) => c.country_name === "India");
        if (india) {
          setSelectedCountry({
            value: india.country_id,
            label: `${india.flag} ${india.code}`,
            code: india.code.replace("+", ""),
            flag: india.flag,
            name: india.country_name,
            id: india.id,
          });
        }
      }
    } catch (error) {
      console.error("Error fetching currencies:", error);
    }
  }, [selectedCountry]);

  useEffect(() => {
    fetchCurrency();
  }, [fetchCurrency]);

  const countryOptions = currencies.map((item) => ({
    value: item.country_id,
    label: `${item.flag} ${item.code}`,
    code: item.code.replace("+", ""),
    flag: item.flag,
    name: item.country_name,
    id: item.id,
  }));

  const filterOption = (option, inputValue) => {
    const input = inputValue.toLowerCase();
    return (
      option.data.name.toLowerCase().includes(input) ||
      option.data.code.includes(input) ||
      option.data.label.toLowerCase().includes(input)
    );
  };

  return (
    <>
      <div className="d-flex min-vh-100" style={{ backgroundColor: "#f8f9fa" }}>
        <div className="container my-auto">
          <div className="row justify-content-center">
            <div className="col-md-8 col-lg-6">
              <div className="card shadow-sm rounded-lg border-0">
                <div
                  className="card-header text-white text-center py-4"
                  style={{
                    backgroundColor: "#085f9a",
                    borderTopLeftRadius: "12px",
                    borderTopRightRadius: "12px",
                  }}
                >
                  <h3 className="mb-0 fw-bold">
                    {language === "en"
                      ? "Excellent! Let's Create An Outstanding Profile"
                      : "बेहतरीन! चलिए एक उत्कृष्ट प्रोफाइल बनाते हैं"}
                  </h3>
                </div>
                <div className="card-body p-5">
                  <form
                    onSubmit={
                      currentTab === "Email"
                        ? handleEmailSignup
                        : showOtp
                          ? handleOtpVerify
                          : handleSendOtp
                    }
                  >
                    {/* Business Name Field */}
                    <div className="mb-4">
                      <label
                        htmlFor="business_name"
                        className="form-label fw-semibold"
                      >
                        {language === "en" ? "Business Name" : "व्यवसाय का नाम"}{" "}
                        <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        id="business_name"
                        name="business_name"
                        placeholder={
                          language === "en"
                            ? "Enter your business name"
                            : "अपना व्यवसाय नाम दर्ज करें"
                        }
                        className={`form-control form-control-lg ${
                          errors.business_name ? "is-invalid" : ""
                        }`}
                        value={formData.business_name}
                        onChange={handleChange}
                        required
                      />
                      {errors.business_name && (
                        <div className="invalid-feedback">
                          {errors.business_name}
                        </div>
                      )}
                    </div>
                    <div className="mb-4">
                      <div className="d-flex rounded-lg overflow-hidden border">
                        <button
                          type="button"
                          className={`btn flex-fill py-3 ${
                            currentTab === "Mobile"
                              ? "btn-primary text-white"
                              : "btn-light text-dark"
                          }`}
                          style={{
                            backgroundColor:
                              currentTab === "Mobile"
                                ? "#085f9a"
                                : "transparent",
                            border: "none",
                            borderRadius: "0",
                          }}
                          onClick={() => switchTab("Mobile")}
                        >
                          <i className="bi bi-phone me-2"></i>
                          {language === "en" ? "Mobile" : "मोबाइल"}
                        </button>
                        <button
                          type="button"
                          className={`btn flex-fill py-3 ${
                            currentTab === "Email"
                              ? "btn-primary text-white"
                              : "btn-light text-dark"
                          }`}
                          style={{
                            backgroundColor:
                              currentTab === "Email"
                                ? "#085f9a"
                                : "transparent",
                            border: "none",
                            borderRadius: "0",
                          }}
                          onClick={() => switchTab("Email")}
                        >
                          <i className="bi bi-envelope me-2"></i>
                          {language === "en" ? "Email" : "ईमेल"}
                        </button>
                      </div>
                    </div>

                    {/* Email Tab Content */}
                    {currentTab === "Email" && (
                      <>
                        <div className="mb-4">
                          <label
                            htmlFor="email"
                            className="form-label fw-semibold"
                          >
                            {language === "en" ? "Email Address" : "ईमेल पता"}{" "}
                            <span className="text-danger">*</span>
                          </label>
                          <input
                            type="email"
                            id="email"
                            name="email"
                            className={`form-control form-control-lg ${
                              errors.email ? "is-invalid" : ""
                            }`}
                            value={formData.email}
                            onChange={handleChange}
                            placeholder={
                              language === "en"
                                ? "Enter your email address"
                                : "अपना ईमेल पता दर्ज करें"
                            }
                            required
                          />
                          {errors.email && (
                            <div className="invalid-feedback">
                              {errors.email}
                            </div>
                          )}
                        </div>

                        <div className="mb-4">
                          <label
                            htmlFor="password"
                            className="form-label fw-semibold"
                          >
                            {language === "en"
                              ? "Create Password"
                              : "पासवर्ड बनाएं"}{" "}
                            <span className="text-danger">*</span>
                          </label>

                          <div className="input-group">
                            <input
                              type={showPassword ? "text" : "password"}
                              id="password"
                              name="password"
                              aria-describedby="basic-addon2"
                              placeholder={
                                language === "en"
                                  ? "Create your password (min. 6 characters)"
                                  : "अपना पासवर्ड बनाएं (न्यूनतम 6 अक्षर)"
                              }
                              className={`form-control form-control-lg ${
                                errors.password ? "is-invalid" : ""
                              }`}
                              value={formData.password}
                              onChange={handleChange}
                              required
                            />
                            <div className="input-group-append">
                              <span
                                className="input-group-text"
                                id="basic-addon2"
                                style={{
                                  borderColor: "#ced4da",
                                  backgroundColor: "transparent",
                                  minHeight: "41px",
                                  cursor: "pointer",
                                }}
                                onClick={() => setShowPassword(!showPassword)}
                              >
                                {showPassword ? (
                                  <MdRemoveRedEye className="text-muted" />
                                ) : (
                                  <IoMdEyeOff className="text-muted" />
                                )}
                              </span>
                            </div>
                            {/* <button
                              className="btn btn-outline-secondary border-start-0"
                              type="button"
                              onClick={() => setShowPassword(!showPassword)}
                              style={{
                                borderColor: "#ced4da",
                                backgroundColor: "transparent",
                              }}
                            >
                              {showPassword ? (
                                <MdRemoveRedEye className="text-muted" />
                              ) : (
                                <IoMdEyeOff className="text-muted" />
                              )}
                            </button> */}
                          </div>
                          {errors.password && (
                            <div className="invalid-feedback">
                              {errors.password}
                            </div>
                          )}
                          <small className="text-muted">
                            {language === "en"
                              ? "Create a strong password for your account"
                              : "अपने खाते के लिए एक मजबूत पासवर्ड बनाएं"}
                          </small>
                        </div>

                        {/* Optional Mobile Number for Email Signup */}
                        <div className="mb-4">
                          <label
                            htmlFor="mobno"
                            className="form-label fw-semibold"
                          >
                            {language === "en"
                              ? "Mobile Number"
                              : "मोबाइल नंबर"}
                            <small className="text-muted ms-1">
                              ({language === "en" ? "Optional" : "वैकल्पिक"})
                            </small>
                          </label>
                          <div className="input-group">
                            <Select
                              options={countryOptions}
                              value={selectedCountry}
                              onChange={setSelectedCountry}
                              menuPosition="fixed"
                              filterOption={filterOption}
                              isSearchable
                              placeholder="🌍 Search..."
                              styles={{
                                control: (provided) => ({
                                  ...provided,
                                  minHeight: "41px",
                                  border: "1px solid #e2e8f0",
                                  borderRight: "none",
                                  borderRadius: "8px 0px 0px 8px",
                                  boxShadow: "none",
                                  "&:hover": {
                                    borderColor: "#e2e8f0",
                                  },
                                }),
                                input: (provided) => ({
                                  ...provided,
                                  padding: "0",
                                  margin: "0",
                                }),
                                singleValue: (provided) => ({
                                  ...provided,
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "6px",
                                }),
                                dropdownIndicator: (provided) => ({
                                  ...provided,
                                  padding: "0 8px",
                                  color: "#64748b",
                                }),
                                indicatorSeparator: () => null,
                                menu: (provided) => ({
                                  ...provided,
                                  zIndex: 9999,
                                }),
                                option: (provided, state) => ({
                                  ...provided,
                                  backgroundColor: state.isSelected
                                    ? "#f1f5f9"
                                    : "white",
                                  color: "#334155",
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "8px",
                                  "&:hover": {
                                    backgroundColor: "#f8fafc",
                                  },
                                }),
                              }}
                              components={{
                                IndicatorSeparator: () => null,
                              }}
                            />
                            <input
                              type="tel"
                              id="mobno"
                              name="mobno"
                              placeholder={
                                language === "en"
                                  ? "Enter mobile number (optional)"
                                  : "मोबाइल नंबर दर्ज करें (वैकल्पिक)"
                              }
                              className={`form-control form-control-lg ${
                                errors.mobno ? "is-invalid" : ""
                              }`}
                              value={formData.mobno}
                              onChange={handleChange}
                              maxLength={10}
                            />
                          </div>
                          {errors.mobno && (
                            <div className="invalid-feedback d-block">
                              {errors.mobno}
                            </div>
                          )}
                        </div>
                      </>
                    )}

                    {/* Mobile Tab Content */}
                    {currentTab === "Mobile" && (
                      <>
                        {!showOtp ? (
                          <div className="mb-4">
                            <label
                              htmlFor="mobno"
                              className="form-label fw-semibold"
                            >
                              {language === "en"
                                ? "Mobile Number"
                                : "मोबाइल नंबर"}{" "}
                              <span className="text-danger">*</span>
                            </label>
                            <div className="input-group">
                              <Select
                                options={countryOptions}
                                value={selectedCountry}
                                onChange={setSelectedCountry}
                                menuPosition="fixed"
                                filterOption={filterOption}
                                isSearchable
                                placeholder="🌍 Search..."
                                styles={{
                                  control: (provided) => ({
                                    ...provided,
                                    minHeight: "41px",
                                    border: "1px solid #e2e8f0",
                                    borderRight: "none",
                                    borderRadius: "8px 0px 0px 8px",
                                    boxShadow: "none",
                                    "&:hover": {
                                      borderColor: "#e2e8f0",
                                    },
                                  }),
                                  input: (provided) => ({
                                    ...provided,
                                    padding: "0",
                                    margin: "0",
                                  }),
                                  singleValue: (provided) => ({
                                    ...provided,
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "6px",
                                  }),
                                  dropdownIndicator: (provided) => ({
                                    ...provided,
                                    padding: "0 8px",
                                    color: "#64748b",
                                  }),
                                  indicatorSeparator: () => null,
                                  menu: (provided) => ({
                                    ...provided,
                                    zIndex: 9999,
                                  }),
                                  option: (provided, state) => ({
                                    ...provided,
                                    backgroundColor: state.isSelected
                                      ? "#f1f5f9"
                                      : "white",
                                    color: "#334155",
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "8px",
                                    "&:hover": {
                                      backgroundColor: "#f8fafc",
                                    },
                                  }),
                                }}
                                components={{
                                  IndicatorSeparator: () => null,
                                }}
                              />
                              <input
                                type="tel"
                                id="mobno"
                                name="mobno"
                                placeholder={
                                  language === "en"
                                    ? "Enter your mobile number"
                                    : "अपना मोबाइल नंबर दर्ज करें"
                                }
                                className={`form-control form-control-lg ${
                                  errors.mobno ? "is-invalid" : ""
                                }`}
                                value={formData.mobno}
                                onChange={handleChange}
                                maxLength={10}
                                required
                              />
                            </div>
                            {errors.mobno && (
                              <div className="invalid-feedback d-block">
                                {errors.mobno}
                              </div>
                            )}
                          </div>
                        ) : (
                          <div className="mb-4">
                            <label
                              htmlFor="otp"
                              className="form-label fw-semibold"
                            >
                              {language === "en"
                                ? "OTP Verification"
                                : "OTP सत्यापन"}{" "}
                              <span className="text-danger">*</span>
                            </label>
                            <input
                              type="tel"
                              id="otp"
                              name="otp"
                              className={`form-control form-control-lg ${
                                errors.otp ? "is-invalid" : ""
                              }`}
                              value={formData.otp}
                              onChange={handleChange}
                              maxLength={6}
                              placeholder={
                                language === "en"
                                  ? "Enter 6-digit OTP"
                                  : "6-अंकीय OTP दर्ज करें"
                              }
                              required
                            />
                            {errors.otp && (
                              <div className="invalid-feedback">
                                {errors.otp}
                              </div>
                            )}
                            <div className="d-flex justify-content-between align-items-center">
                              <small className="text-muted">
                                {language === "en"
                                  ? `OTP sent to +${
                                      selectedCountry?.code || "91"
                                    } ${formData.mobno}`
                                  : `OTP भेजा गया +${
                                      selectedCountry?.code || "91"
                                    } ${formData.mobno}`}
                              </small>
                              <div>
                                {showOtp &&
                                  (canResend ? (
                                    <button
                                      type="button"
                                      onClick={resendVerificationCode}
                                      disabled={loading}
                                      className="btn btn-link btn-sm"
                                      style={{
                                        color: "#085f9a",
                                        fontSize: "14px",
                                      }}
                                    >
                                      Resend OTP
                                    </button>
                                  ) : (
                                    <span className="text-muted small">
                                      Resend in {resendTimer}s
                                    </span>
                                  ))}
                              </div>
                            </div>
                          </div>
                        )}
                      </>
                    )}

                    {/* Referral Code */}
                    {/* <div className="mb-4">
                      <label htmlFor="refer_code" className="form-label fw-semibold">
                        {language === "en" ? "Referral Code" : "रेफरल कोड"}
                        <small className="text-muted ms-1">
                          ({language === "en" ? "Optional" : "वैकल्पिक"})
                        </small>
                      </label>
                      <input
                        type="text"
                        id="refer_code"
                        name="refer_code"
                        className="form-control form-control-lg"
                        value={formData.refer_code}
                        onChange={handleChange}
                        placeholder={
                          language === "en" 
                            ? "Enter referral code if any" 
                            : "यदि कोई हो तो रेफरल कोड दर्ज करें"
                        }
                      />
                    </div> */}

                    {/* Terms and Conditions */}
                    <div className="mb-4 form-check">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id="agreeToTerms"
                        checked={agreeToTerms}
                        onChange={(e) => setAgreeToTerms(e.target.checked)}
                        required
                      />
                      <label
                        className="form-check-label"
                        htmlFor="agreeToTerms"
                      >
                        {language === "en"
                          ? "I agree to the "
                          : "मैं सहमत हूं "}
                        <a
                          href="#!"
                          onClick={(e) => {
                            e.preventDefault();
                            setShowTermsModal(true);
                          }}
                          style={{ color: "#085f9a", textDecoration: "none" }}
                        >
                          {language === "en"
                            ? "Terms and Conditions"
                            : "नियम और शर्तें"}
                        </a>
                      </label>
                    </div>

                    {/* Submit Button */}
                    <div className="d-grid mt-4">
                      <button
                        type="submit"
                        className="btn text-white py-3 fw-semibold rounded-lg"
                        style={{
                          backgroundColor: "#085f9a",
                          fontSize: "16px",
                        }}
                        disabled={
                          loading ||
                          !agreeToTerms ||
                          !formData.business_name ||
                          (currentTab === "Email"
                            ? !formData.email ||
                              !formData.password ||
                              errors.email ||
                              errors.password
                            : showOtp
                              ? !formData.otp || errors.otp
                              : !formData.mobno || errors.mobno)
                        }
                      >
                        {loading ? (
                          <span
                            className="spinner-border spinner-border-sm me-2"
                            role="status"
                            aria-hidden="true"
                          ></span>
                        ) : null}
                        {loading
                          ? language === "en"
                            ? "Processing..."
                            : "प्रक्रिया कर रहे हैं..."
                          : showOtp
                            ? language === "en"
                              ? "Verify OTP"
                              : "OTP सत्यापित करें"
                            : currentTab === "Email"
                              ? language === "en"
                                ? "Create Profile"
                                : "प्रोफाइल बनाएं"
                              : language === "en"
                                ? "Send OTP"
                                : "OTP भेजें"}
                      </button>
                    </div>
                  </form>
                  <div className="position-relative mb-4 mt-4">
                    <div className="border-bottom"></div>
                    <div
                      className="position-absolute top-50 start-50 translate-middle px-3 bg-white text-muted"
                      style={{ fontSize: "14px" }}
                    >
                      {language === "en" ? "or continue with" : "या जारी रखें"}
                    </div>
                  </div>
                  <div className="mt-4">
                    <button
                      onClick={handleGoogleLogin}
                      disabled={googleLoading}
                      className="w-100 d-flex align-items-center justify-content-center gap-3 px-4 py-3 bg-white rounded-lg shadow-sm hover:shadow-md transition-all duration-300 border border-gray-300 text-gray-700 font-semibold"
                      style={{
                        fontSize: "16px",
                        minHeight: "52px",
                      }}
                    >
                      {googleLoading ? (
                        <span
                          className="spinner-border spinner-border-sm me-2"
                          role="status"
                          aria-hidden="true"
                        ></span>
                      ) : (
                        <FcGoogle
                          className="text-xl"
                          style={{ fontSize: "24px" }}
                        />
                      )}
                      {googleLoading
                        ? language === "en"
                          ? "Processing..."
                          : "प्रक्रिया कर रहे हैं..."
                        : language === "en"
                          ? "Sign up with Google"
                          : "गूगल के साथ साइन अप करें"}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div id="recaptcha-container"></div>
      </div>

      {/* Terms and Conditions Modal */}
      <Modal
        show={showTermsModal}
        onHide={() => setShowTermsModal(false)}
        centered
        size="lg"
      >
        <Modal.Header closeButton className="border-bottom">
          <Modal.Title className="fw-bold">
            {language === "en" ? "Terms and Conditions" : "नियम और शर्तें"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body
          style={{
            whiteSpace: "pre-line",
            maxHeight: "60vh",
            overflowY: "auto",
          }}
        >
          <h6 className="fw-bold">1. Mandatory Service Charge Payment</h6>
          <p>
            A service charge of 5% (five percent) of the total booking amount is
            compulsorily payable within 24 hours of receiving the advance from
            the client. This charge applies regardless of the amount received,
            as any payment from the client shall be deemed as advance towards
            the confirmed booking.
          </p>

          <h6 className="fw-bold">
            {language === "en"
              ? "What is the service charge and when is it payable?"
              : "सेवा शुल्क क्या है और इसका भुगतान कब करना होता है?"}
          </h6>
          <p>
            {language === "en"
              ? "The service charge is 5% of the total booking amount and must be paid within 24 hours of receiving any advance payment from the client."
              : "सेवा शुल्क कुल बुकिंग राशि का 5% है और ग्राहक से कोई अग्रिम भुगतान प्राप्त होने के 24 घंटे के भीतर इसका भुगतान किया जाना चाहिए।"}
          </p>
          <p>
            जब भी किसी क्लाइंट से आपको कोई एडवांस भुगतान प्राप्त होता है, उस कुल
            राशि का 5% (पाँच प्रतिशत) सेवा शुल्क के रूप में Event Planet को
            भुगतान करना अनिवार्य है। इस भुगतान को क्लाइंट से एडवांस मिलने के 24
            घंटों के भीतर करना होता है। यह नियम सभी एडवांस भुगतान पर लागू होगा,
            चाहे राशि कितनी भी हो। कोई भी राशि एडवांस मानी जाएगी और उस पर सेवा
            शुल्क लागू होगा।
          </p>

          {/* Point 2 */}
          <h6 className="fw-bold">2. Consequences of Non-Payment</h6>
          <p>
            Failure to comply with the above payment timeline shall result in
            the temporary suspension of the venue listing for a period of six
            (6) months. Repeated non-compliance may lead to permanent delisting
            from the Event Planet platform without further notice.
          </p>

          <h6 className="fw-bold">
            यदि समय पर सेवा शुल्क का भुगतान नहीं किया गया तो ?
          </h6>
          <p>
            अगर निर्धारित समय (24 घंटे) में सेवा शुल्क का भुगतान नहीं किया गया,
            तो संबंधित वेन्यू की लिस्टिंग को छह (6) महीने के लिए अस्थायी रूप से
            सस्पेंड कर दिया जाएगा। बार-बार ऐसा करने पर वेन्यू को Event Planet
            प्लेटफ़ॉर्म से स्थायी रूप से हटा दिया जा सकता है, बिना किसी अतिरिक्त
            सूचना के।
          </p>

          {/* Point 3 */}
          <h6 className="fw-bold">3. Nature and Purpose of Service Charge</h6>
          <p>
            The service charge levied by Event Planet is a non-refundable
            professional fee against services rendered, including but not
            limited to lead generation, digital marketing, promotion, and
            facilitation of client bookings for your venue through our platform
            and network.
          </p>

          <h6 className="fw-bold">सेवा शुल्क का उद्देश्य और प्रकृति ?</h6>
          <p>
            Event Planet द्वारा लिया गया सेवा शुल्क एक गैर-वापसी शुल्क है, जो
            आपकी वेन्यू की मार्केटिंग, डिजिटल प्रचार, लीड जनरेशन, और क्लाइंट
            बुकिंग को सुविधाजनक बनाने जैसी सेवाओं के लिए होता है।
          </p>

          {/* Point 4 */}
          <h6 className="fw-bold">Non-Refundable Clause</h6>
          <p>
            In the event of cancellation of booking by the client, Event Planet
            shall not be liable to refund or reimburse the service charge to the
            venue under any circumstances, as the charge pertains to marketing
            efforts already expended.
          </p>

          <h6 className="fw-bold">सेवा शुल्क की वापसी की शर्तें ?</h6>
          <p>
            अगर क्लाइंट किसी कारण से बुकिंग को रद्द कर देता है, तब भी यह सेवा
            शुल्क वापस नहीं किया जाएगा, क्योंकि यह शुल्क उन प्रयासों के लिए होता
            है जो पहले ही किए जा चुके होते हैं (जैसे प्रचार और मार्केटिंग
            इत्यादि)।
          </p>

          {/* Point 5 */}
          <h6 className="fw-bold">5. Accepted Mode of Payment</h6>
          <p>
            The service charge must be exclusively processed through the secure
            payment system available in the Vendor Panel of Event Planet. No
            other mode or method of payment will be accepted or recognized.
          </p>

          <h6 className="fw-bold">भुगतान का स्वीकृत तरीका ?</h6>
          <p>
            सेवा शुल्क का भुगतान केवल Event Planet के Vendor Panel में उपलब्ध
            सुरक्षित पेमेंट सिस्टम के माध्यम से ही किया जाएगा। किसी अन्य माध्यम
            से किया गया भुगतान मान्य नहीं होगा और उसे स्वीकार नहीं किया जाएगा।
          </p>

          <h6 className="fw-bold">6. Right to Modify Terms and Conditions</h6>
          <p>
            The Company reserves the right, at its sole discretion, to modify,
            amend, or update these Terms and Conditions, in whole or in part, at
            any time, in response to evolving business requirements, changes in
            applicable laws, market conditions, or operational needs. Any such
            modifications shall become effective upon publication on the
            Company’s official website or by such other means as deemed
            appropriate. Continued use of the Company's services or engagement
            with the Company after such changes shall constitute acknowledgment
            and acceptance of the revised Terms and Conditions.
          </p>
          <h6 className="fw-bold">नियम और शर्तों में संशोधन का अधिकार</h6>
          <p>
            कंपनी को यह पूर्ण अधिकार प्राप्त है कि वह किसी भी समय, अपने
            विवेकानुसार, व्यावसायिक आवश्यकताओं, प्रचलित क़ानूनों में हुए
            परिवर्तनों, बाज़ार की परिस्थितियों अथवा संचालन संबंधी आवश्यकताओं के
            अनुसार, इन नियमों और शर्तों को आंशिक या पूर्ण रूप से संशोधित,
            परिवर्तित या अद्यतन कर सके। ऐसे किसी भी संशोधन के प्रभावी होने की
            तिथि कंपनी की आधिकारिक वेबसाइट पर प्रकाशित किए जाने या कंपनी द्वारा
            उपयुक्त माने गए अन्य माध्यमों से सूचित किए जाने के पश्चात होगी।
            कंपनी की सेवाओं का निरंतर उपयोग या कंपनी से जुड़ाव बनाए रखना,
            संशोधित नियमों और शर्तों की स्वीकृति मानी जाएगी।
          </p>
          <h6 className="fw-bold">7. Dispute Resolution and Governing Law</h6>
          <p>
            In the event of any dispute arising out of or in connection with
            this agreement, the parties shall first seek to resolve the matter
            amicably through mediation. If unresolved within 30 days, the
            dispute shall be referred to binding arbitration in Lucknow, Uttar
            Pradesh, in accordance with the provisions of the Arbitration and
            Conciliation Act, 1996. This agreement shall be governed by the laws
            of the State of Uttar Pradesh, and each party shall bear its own
            legal costs, unless otherwise directed by the arbitrator.
          </p>
          <h6 className="fw-bold">विवाद निवारण एवं अधिकार क्षेत्र</h6>
          <p>
            इस समझौते से उत्पन्न या उससे संबंधित किसी भी विवाद की स्थिति में,
            पक्षकार सर्वप्रथम आपसी सहमति से समाधान करने का प्रयास करेंगे। यदि
            विवाद 30 दिनों की अवधि में सुलझाया नहीं जा सके, तो उसे लखनऊ, उत्तर
            प्रदेश स्थित क्षेत्राधिकार वाले न्यायाधिकरण में, भारतीय मध्यस्थता और
            सुलह अधिनियम, 1996 के अंतर्गत बाध्यकारी मध्यस्थता हेतु भेजा जाएगा।
            यह समझौता उत्तर प्रदेश राज्य के अधिनियमों द्वारा शासित होगा, और
            प्रत्येक पक्ष अपने स्वयं के कानूनी व्यय वहन करेगा, जब तक कि मध्यस्थ
            द्वारा अन्यथा निर्देशित न किया जाए।
          </p>
        </Modal.Body>
        <Modal.Footer className="border-top">
          <button
            className="btn btn-primary px-4"
            onClick={() => setShowTermsModal(false)}
          >
            {language === "en" ? "Close" : "बंद करें"}
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default CreateProfile;